import { CircularProgress } from '@mui/material';
import React from 'react';

const LoadingCircular = () => {
  return (
    <div className='flex h-full items-center justify-center'>
      <CircularProgress color='primary' />
    </div>
  );
};

export default LoadingCircular;
